module.exports = __webpack_public_path__ + "static/blog55-6490137613b01fc0fdb72b80c57561c4.png";